var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAmended(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.7)  translate(5, 5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 18.0025H3.75L14.81 6.9425L11.06 3.1925L0 14.2525V18.0025ZM2 15.0825L11.06 6.02251L11.98 6.9425L2.92 16.0025H2V15.0825Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3699 0.2925C14.9799 -0.0975 14.3499 -0.0975 13.9599 0.2925L12.1299 2.1225L15.8799 5.8725L17.7099 4.0425C18.0999 3.6525 18.0999 3.0225 17.7099 2.6325L15.3699 0.2925Z",
    fill: "#263238"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmended);
export default __webpack_public_path__ + "static/media/Amended.fc91102eaccccd3ab654fd577a925fae.svg";
export { ForwardRef as ReactComponent };